import { connect } from 'react-redux';
import JournalistSinglePage from '../components/journalistSinglePageComponent';
import {
    getJournalistsData,
    getJournalistNews,
} from '../actions/journalistsActions';

const mapStateToProps = (state) => ({
    journalistsData: state.journalists.journalistsData,
    isLoadingNews: state.journalists.isLoadingNews,
    isLoadingData: state.journalists.isLoadingData,
});
const mapDispatchToProps = (dispatch) => ({
    getJournalistsData: () => {
        dispatch(getJournalistsData());
    },
    getJournalistNews: (id, num, init) => {
        dispatch(getJournalistNews(id, num, init));
    },
});
const JournalistSinglePageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(JournalistSinglePage);

export default JournalistSinglePageContainer;
